import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setToken } = useAuth();

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (token) {
      setToken(token).then(() => {
        navigate("/", { replace: true });
      });
    } else if (error) {
      navigate("/login?error=" + error, { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [searchParams, setToken, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-800 border-t-transparent" />
    </div>
  );
}
